{
  "version": 1,
  "asset_id": "f38f6bb2-99dc-425c-b417-e10002efdc5f",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/f38f6bb2-99dc-425c-b417-e10002efdc5f/lpgas-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/f38f6bb2-99dc-425c-b417-e10002efdc5f/lpgas-hero.webp",
  "original_filename": "lpgas-hero.webp",
  "size": 49304,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:31:06Z"
}
